import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../servicios/api/api.service';
import { FuentesComponent } from '../directorio/fuentes/fuentes.component';
import { VariableschvComponent } from '../directorio/variableschv/variableschv.component';
import { VariablesfiviComponent } from '../directorio/variablesfivi/variablesfivi.component';
import { CargandoService } from '../plantillas/cargando/cargando.service';

@Component({
  selector: 'app-directorio',
  templateUrl: './directorio.component.html',
  styleUrls: ['./directorio.component.css']
})
export class DirectorioComponent implements OnInit {

  constructor(
    private api:ApiService,
    private loadingService: CargandoService,
    private router:Router) { }

  ngOnInit(): void {
  }

  goFuentes(){
    this.router.navigate(['fuentes']);
    this.loadingService.setLoading(true);
  }

  goVariableschv(){
    this.router.navigate(['variableschv']);
  }

  goVariablesfivi(){
    this.router.navigate(['variablesfivi']);
  }

}
